const steps = [
  {
    no: "01",
    title: "比对分项名称",
    text: "把现场公示、组委会留档与赛后通稿里的分项名称逐条对齐。名称被拆分或合并，往往就是名次变化的起点。",
  },
  {
    no: "02",
    title: "合计权重占比",
    text: "每一项权重相加必须等于百分之百。只要有一项在赛后被调整过又没有说明，整张表的可信度都要重新评估。",
  },
  {
    no: "03",
    title: "确认同分规则",
    text: "同分时是重新投票、比较最高分项，还是参考初赛成绩？规则如果没在赛前写明，结果就只能被解释，不能被推导。",
  },
];

const cases = [
  { label: "现场公示分", detail: "形体表现合并计一栏，权重 20%", result: "A 组第一" },
  { label: "组委会留档分", detail: "拆为台步与镜头感，各占 10%", result: "B 组第一" },
  { label: "赛后通稿引用分", detail: "引用留档分但删除拆分说明", result: "A 组第一" },
];

export default function MethodSection() {
  return (
    <section id="method" className="scroll-mt-24 border-y border-background-200 bg-secondary-100">
      <div className="mx-auto w-full px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <span className="flex items-center gap-2 font-label text-xs tracking-[0.2em] text-primary-600">
              <i className="ri-scales-3-line" aria-hidden="true"></i>
              METHOD
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              评分猫腻解析：三步核对法
            </h2>
            <p className="mt-4 text-sm leading-loose text-foreground-700">
              不需要内部资料，普通观众也能自己复核一场比赛。这套方法我们每篇文章都会走一遍，也是判断一条爆料是否值得写下去的第一道门槛。
            </p>

            <div className="mt-8 space-y-4">
              {steps.map((step) => (
                <div key={step.no} className="flex gap-4 rounded-lg border border-secondary-200 bg-background-50 p-5">
                  <span className="font-heading text-2xl font-black text-accent-500">{step.no}</span>
                  <div>
                    <h3 className="font-heading text-base font-bold text-foreground-950">{step.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-700">{step.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
              <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-file-list-3-line text-primary-600" aria-hidden="true"></i>
                口径差异示例（已脱敏）
              </h3>
              <p className="mt-2 text-sm text-foreground-600">
                同一场决赛的三份表格，对同一分项给出了三种处理方式，于是产生了三个冠军。
              </p>

              <div className="mt-6 overflow-x-auto">
                <table className="w-full min-w-[520px] border-collapse text-left text-sm">
                  <thead>
                    <tr className="border-b-2 border-foreground-900">
                      <th className="py-3 pr-4 font-label text-xs font-semibold tracking-wide text-foreground-600">表格来源</th>
                      <th className="py-3 pr-4 font-label text-xs font-semibold tracking-wide text-foreground-600">处理方式</th>
                      <th className="py-3 font-label text-xs font-semibold tracking-wide text-foreground-600">得出名次</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cases.map((row) => (
                      <tr key={row.label} className="border-b border-background-200">
                        <td className="py-4 pr-4 font-medium text-foreground-900">{row.label}</td>
                        <td className="py-4 pr-4 leading-relaxed text-foreground-700">{row.detail}</td>
                        <td className="py-4">
                          <span className="rounded-full bg-primary-100 px-3 py-1 font-label text-xs text-primary-800">
                            {row.result}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="mt-6 rounded-md border-l-4 border-accent-500 bg-accent-50 p-5">
                <p className="text-sm leading-loose text-accent-950">
                  <strong className="font-semibold">判断标准：</strong>
                  如果把规则提前公开，还能不能得到同样的冠军。能，就是赛制；不能，就是操作。口径被调整不等于名次被内定，但未公示的调整，就是可以被利用的缝隙。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}